import { Location } from '@angular/common';
import { Component, OnInit, Injectable } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner/typings/progress-spinner';
import { Router, ActivatedRoute } from '@angular/router';

import { GlobalDataService } from '@providers/global-data/global-data.service';
import { GlobalFunctionService } from '@providers/global-function/global-function.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.less']
})
@Injectable()
export class QuotationComponent implements OnInit {
  public route: string;

  public isDownload: boolean = false;

  public quotationId: any;
  public quotation:any;
  public versionId: any;
  public quotationVersion: any;
  public quotationNumber: any;
  public totalPrice: any;
  diameter = 25;
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  public financial: any;
  public chapters: any;
  public project: any;

  constructor(
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private requestService: RequestService,
    private requestV2Service: RequestV2Service,
    public globalFunction: GlobalFunctionService,
    public globalDataService: GlobalDataService
  ) {
    router.events.subscribe(() => {
      if (location.path() !== '') {
        this.route = location.path();
      } else {
        this.route = 'Home';
      }
    });
  }

  ngOnInit() {
    this.retrieveVersionQuotationData();
  }

  public async retrieveVersionQuotationData(): Promise<any> {
    this.activatedRoute.params.subscribe(async (params) => {
      this.quotationId = params['qid'];
      this.versionId = params['vid'];
      const versionResult = await this.requestV2Service.getVersion(this.versionId);
      const financial = await this.requestV2Service.getQuotationVersionFinancial(this.versionId);
      this.globalDataService.financial = financial;
      this.quotation = await this.requestV2Service.getQuotation(this.quotationId);
      this.project = await this.requestV2Service.getProject(this.quotation.id_project, true);
      this.globalDataService.setCurrentProjectId(this.project.id);
      this.globalDataService.setCurrentProject(this.project);
      const chaptersResult = await this.requestV2Service.getChapters(this.versionId);
      this.chapters = chaptersResult.items;
      this.quotationVersion = versionResult;
      this.quotationNumber = this.versionId;
    });
  }

  public getTva() : number {
    if (this.globalDataService.financial) {
      const totalTVA = this.globalDataService.financial.customer.vat[10]
        + this.globalDataService.financial.customer.vat[20]
        + this.globalDataService.financial.customer.vat[5.5];

      return totalTVA;
    }

    return 10;
  }

  public downloadCustomer(): any {
    this.isDownload = true;
    this.requestV2Service.downloadQuotationVersion(this.versionId, 'customer', 'pdf', false)
       .then((data) => {
         this.downloadFile(data);
         this.isDownload = false;
       });
  }

  // Create and download file
  public downloadFile(data): void {
    const filename = this.getFileNameFromHttpResponse(data);
    const blob = new Blob([data.body], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    document.body.appendChild(a);

    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
  }

  // Extract content-disposition headers value
  public getFileNameFromHttpResponse(httpResponse: any): any {
    const contentDispositionHeader = httpResponse.headers.get('content-disposition');
    const result = contentDispositionHeader
      .split(';')[1]
      .trim()
      .split('=')[1];

    return result.replace(/"/g, '');
  }
}
